<template lang="pug">
    div
        ListItem
            ListItemMeta(:title="$t('accountInfo.coupon.couponText')") 
                template(slot="description")
                    p {{description}}
            template(slot="extra") 
                li
                    Button.cardBtn(type="primary" @click="openModel" :disabled="!userInfoData.subscription") {{ $t('accountInfo.coupon.couponBtnText') }}
        Modal(v-model="isOpened" :title="modalTitle" footer-hide width="600")
            Card(dis-hover)
                div(style="display: flex; flex-direction: row; align-items: center")
                    Icon(type="md-pricetag")
                    p.cardTitle {{ $t('accountInfo.coupon.couponInputText') }}:
                Form(style="width: 100%" ref="form" :model="data")
                    FormItem.formItem(prop="couponCode")
                        Input(prefix="md-pricetag"  v-model="data.couponCode")
            .paymentModalFooter
                div(style="width: 100%;text-align: right;")
                    Button.cardBtn(@click="closeModalEvent") {{ $t('accountInfo.cancelBtnText') }}
                    Button.cardBtn(type="primary" @click="updateCoupon" ) {{ $t('accountInfo.coupon.couponApplyBtnText') }}
    
    </template>

<script>
import { _getSubscriptions, _updateCoupons } from "@/api/billing";

export default {
    name: "CouponListItem",
    props: ["userInfoData", "total_discount_amounts"],
    data() {
        return {
            isOpened: false,
            data: {
                couponCode: "",
            },
            endDate: "",
        };
    },
    methods: {
        openModel() {
            this.isOpened = true;
        },
        mes() {
            if (this.data.couponCode == "") {
                this.$Message.error("請輸入優惠碼");
            }
            return this.data.couponCode != "";
        },
        async updateCoupon() {
            if (this.mes()) {
                let updateCoupons = await _updateCoupons({
                    groupName: this.$store.state.queryGroupName,
                    subscriptionId: this.userInfoData.subscription.subscriptionId,
                    couponCode: this.data.couponCode,
                });
                if (updateCoupons.data.success) {
                    this.$Message.success(this.$t("global.success"));
                    this.$emit("reloadPaymentView");
                    this.data.couponCode = "";
                    this.isOpened = false;
                } else {
                    this.$Message.error(`${this.$t("global.error")} : ${updateCoupons.data.data.coupon.error}`);
                }
            }
        },
        async getSubscription() {
            let result = await _getSubscriptions({
                groupName: this.$store.state.queryGroupName,
                customerId: this.userInfoData.customerId,
            });
            let endDate =
                result.data.data.subscriptions.data.length > 0
                    ? result.data.data.subscriptions.data[0].discount.end
                    : "";

            this.endDate = endDate;
        },
        closeModalEvent() {
            this.data.couponCode = "";
            this.isOpened = false;
        },
    },
    mounted() {},
    created() {
        this.getSubscription();
    },
    computed: {
        modalTitle() {
            return "請輸入優惠碼";
        },
        description() {
            let endDate = "";
            if (this.endDate) {
                let date = new Date(this.endDate * 1000);
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                endDate = year + "/" + month + "/01";
            }
            return this.total_discount_amounts.name
                ? this.total_discount_amounts.name + " (expiry date:" + endDate + ")"
                : "";
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Payment/coupon/listItem.vue